import React from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import { Link } from 'react-router-dom';
import styles from 'shop-views/StripeView.scss';
import { CogSvg } from '../../../icons/index.js';

var ProductsList = _ref => {
  var items = _ref.items,
      formatPoints = _ref.formatPoints,
      formatPrice = _ref.formatPrice,
      checkoutRoute = _ref.checkoutRoute,
      checkoutContent = _ref.checkoutContent;
  var t = useTranslate();
  var hasCheckoutContent = checkoutContent !== null && checkoutContent !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.items
  }, items.map(x => {
    var _x$product$attributes, _x$selectedPointPayme, _x$selectedPointPayme2;

    return /*#__PURE__*/React.createElement("div", {
      key: x.itemBuyRequest,
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.left
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.image,
      alt: x.product.name,
      src: (_x$product$attributes = x.product.attributes.image) == null ? void 0 : _x$product$attributes.x1
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.info
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: styles.name
    }, x.product.name), /*#__PURE__*/React.createElement("p", {
      className: styles.brand
    }, x.product.attributes.manufacturer)), /*#__PURE__*/React.createElement("span", {
      className: styles.price
    }, (x.selectedPointPayment === undefined || x.selectedPointPayment === null) && formatPrice(x.rowTotal.incVat), x.selectedPointPayment !== undefined && x.selectedPointPayment !== null && formatPoints ? (_x$selectedPointPayme = x.selectedPointPayment) != null && _x$selectedPointPayme.points.value.exVat ? formatPoints(x.selectedPointPayment.points.value.exVat || 0) : formatPrice(((_x$selectedPointPayme2 = x.selectedPointPayment) == null ? void 0 : _x$selectedPointPayme2.currency.max.incVat) || 0) : null))), /*#__PURE__*/React.createElement("div", {
      className: styles.right
    }, /*#__PURE__*/React.createElement(Link, {
      className: styles.link,
      to: `${checkoutRoute && checkoutRoute.url ? checkoutRoute.url : "/checkout"}/cart`
    }, hasCheckoutContent ? checkoutContent == null ? void 0 : checkoutContent.edit : t("CHECKOUT.EDIT"), /*#__PURE__*/React.createElement("img", {
      src: CogSvg,
      alt: ""
    }))));
  }));
};

export { ProductsList };
//# sourceMappingURL=index.js.map
